import React, { useEffect, useState } from 'react';
import {
  getMoveObservable,
  moveService,
  moveItems,
  setAddNewFolderMoveObservable,
  getAddNewFolderMoveObservable,
  filterItems,
} from '../../Services/Move/Move.service';
import FooterWrapper from './MoveFooterWrapper/FooterWrapper';
import HeaderWrapper from './MoveHeaderWrapper/HeaderWrapper';
import useObservable from '../../../Shared/Hooks/useObservable.Hook';
import { MoveContent } from './MoveContent/MoveContent';
import { st, classes } from './MoveWrapper.st.css';
import { getMoveLoader } from '../../Services/ItemsMove.service';
import { MoveLoadingWrapper } from './MoveLoadingWrapper/MoveLoadingWrapper';
import { getSelectedItems } from '../../Services/SelectedItems.service';
import MoveAddNewFolderOutSideClick from './MoveAddNewFolderOutSideClick';
import MoveAddNewFolderRowClick from './MoveAddNewFolderRowClick';
import { cameFromBack, startMoving } from '../../Services/Move/MovingProccess';
import { getBreadCrumbs } from '../../Services/BreadCrumbs.service';
import { Divider } from 'wix-ui-tpa';
import { moveFileClickBi } from '../../BiEvents/SharedBiEventsCallBack/SharedBiEventsCallBack';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  getAppSettings,
  getSettingsData,
} from '../../Services/AppSettings.service';
import { getSelectedFolder } from '../../Services/SelectedFolder.service';
import { Status } from '../../../Constants/Permissions';
import { getUser } from '../../Services/User.service';
import { ADMIN } from '../../../Constants/Modals.Constants';

const MoveWrapper = (props: any) => {
  const { handleOnCloseMove } = props;
  const { t } = useTranslation();
  const [state, setState]: any = useState({
    isRowClicked: false,
    movingToFolderId: '',
    movingToFolderName: '',
    selectedFolderLibraryItems: [],
    createFolder: {},
  });
  const [, settingsData]: any = useObservable(getSettingsData());
  const selectedFolderIdFromSettings = settingsData?.rootFolderId;
  const [, moveData]: any = useObservable(getMoveObservable());
  const [, moveLoader] = useObservable(getMoveLoader());
  const [, selectedItemsIds]: any = useObservable(getSelectedItems());
  const [, MoveAddFolder]: any = useObservable(
    getAddNewFolderMoveObservable(),
  );
  const [, AppSettings]: any = useObservable(getAppSettings());
  const isMobile = getAppSettings !== undefined ? AppSettings?.isMobile : '';
  const [, breadcrumbs]: any = useObservable(getBreadCrumbs());
  const [, selectedFolder]: any = useObservable(getSelectedFolder());
  const [, user]: any = useObservable(getUser());
  const currentFolderId =
    breadcrumbs?.length > 0 ? breadcrumbs[breadcrumbs.length - 1].id : '';
  const isAdmin: boolean = user?.role === ADMIN;
  const showFolderButton =
    state?.createFolder?.status === Status.ALLOWED || isAdmin;
  useEffect(() => {
    if (selectedFolder) {
      const createFolderObj =
        selectedFolder?.folderAuthorizedActions?.[1] || {};
      setState((prevState: any) => ({
        ...prevState,
        createFolder: createFolderObj,
      }));
    }
  }, [selectedFolder]);
  useEffect(() => {
    moveService();
    return () => {
      setAddNewFolderMoveObservable({ status: false, folderName: '' });
    };
  }, []);
  useEffect(() => {
    const getSelectedFolderLibraryItems = async () => {
      if (selectedItemsIds) {
        const selectedFolderLibraryItems: any = await filterItems(
          selectedItemsIds,
        );
        moveFileBiHelper('click', selectedFolderLibraryItems);
      }
    };
    getSelectedFolderLibraryItems();
  }, [selectedItemsIds]);
  const moveFileBiHelper = (
    description: string,
    selectedFolderLibraryItems: any,
  ) => {
    if (selectedFolderLibraryItems && selectedFolderLibraryItems.length > 0) {
      selectedFolderLibraryItems.map((item: any) => {
        moveFileClickBi(item, description, selectedFolderLibraryItems.length);
      });
    }
  };
  const handleMoveClick = () => {
    if (moveData !== undefined) {
      moveItems({
        newParentFolderId: moveData?.currentFolderId,
        destFolder: {
          name: moveData?.currentFolderName,
          id: moveData?.currentFolderId,
        },
        t,
      });
    }
  };

  const handleIsRowClicked = (
    isRowClicked: boolean,
    movingToFolderId: string,
    movingToFolderName: string,
  ) => {
    if (MoveAddFolder !== undefined && MoveAddFolder.folderName === '') {
      startMoving(movingToFolderId, movingToFolderName);
      return;
    } else {
      setState((prevState: any) => ({
        ...prevState,
        isRowClicked,
        movingToFolderId,
        movingToFolderName,
      }));
    }
  };
  return (
    <>
      {moveData !== undefined ? (
        <div
          className={
            st(classes.moveWrapper, { isMobile }) +
            ' ' +
            (selectedItemsIds !== undefined && selectedItemsIds.length > 0
              ? classes.moveWrapperSelectionMode
              : '') +
            ' ' +
            (isMobile ? classes.moveWrapperMobileView : '')
          }
        >
          <HeaderWrapper
            isMobile={isMobile}
            name={
              moveData.currentFolderId === selectedFolderIdFromSettings
                ? t('root.folder.label')
                : moveData.currentFolderName
            }
            onClick={() => {
              if (moveData.currentFolderId !== selectedFolderIdFromSettings) {
                cameFromBack(
                  moveData.parentFolderId,
                  moveData.parentFolderName,
                );
              }
            }}
            disabled={moveData.currentFolderId !== selectedFolderIdFromSettings}
            onClose={handleOnCloseMove}
          />
          <Divider className={classes.rowDivider} />
          {moveLoader && moveLoader === true ? (
            <MoveLoadingWrapper isMobile={isMobile} />
          ) : (
            <div className={st(classes.rowContentWrapper, { isMobile })}>
              {MoveAddFolder !== undefined && MoveAddFolder?.status === true ? (
                <>
                  {state.isRowClicked === false ? (
                    <MoveAddNewFolderOutSideClick
                      isMobile={isMobile}
                      isRowClicked={state.isRowClicked}
                      handleIsRowClicked={handleIsRowClicked}
                      moveAddFolderFolderName={MoveAddFolder.folderName}
                      moveAddFolderFolderStatus={MoveAddFolder.status}
                    />
                  ) : (
                    <MoveAddNewFolderRowClick
                      isMobile={isMobile}
                      isRowClicked={state.isRowClicked}
                      handleIsRowClicked={handleIsRowClicked}
                      movingToFolderId={state.movingToFolderId}
                      movingToFolderName={state.movingToFolderName}
                    />
                  )}
                </>
              ) : null}
              <>
                <MoveContent
                  isMobile={isMobile}
                  handleIsRowClicked={handleIsRowClicked}
                  currentSubFolders={moveData.currentSubFolders}
                  rootFolderId={moveData.rootFolderId}
                />
              </>
            </div>
          )}
          <Divider className={classes.rowDivider} />
          <FooterWrapper
            showFolderButton={showFolderButton}
            handleMoveClick={handleMoveClick}
            disabled={
              currentFolderId && currentFolderId === moveData?.currentFolderId
            }
            isLoading={moveLoader !== undefined && moveLoader === true}
            handleNewFolder={() => {
              if (
                MoveAddFolder !== undefined &&
                MoveAddFolder.status === false
              ) {
                const newObj = {
                  status: true,
                  folderName: '',
                };
                setState((prevState: any) => ({
                  ...prevState,
                  isRowClicked: false,
                }));
                setAddNewFolderMoveObservable(newObj);
              }
            }}
            isMobile={isMobile}
          />
        </div>
      ) : null}
    </>
  );
};

export default MoveWrapper;
